export default [
  {
    id: 'e867be57-a21b-47bc-85fd-1bdf64f42d22',
    path: 'metadata-manage',
    name: 'metadata-manage',
    meta: { title: '元数据管理' },
    children: [
      {
        id: '5c031145-cade-4820-99fb-5bbe66e60234',
        path: 'collection-manage',
        name: 'collection-manage',
        component: () => {
          return import('../views/metadataManage/collectionManage')
        },
        meta: {
          title: '元数据采集',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            read: {
              id: 4,
              name: 'read',
              desc: '查看',
              access: true,
            },
            testConnection: {
              id: 5,
              name: 'testConnection',
              desc: '测试连接',
              access: true,
            },
            import: {
              id: 6,
              name: 'import',
              desc: '导入',
              access: true,
            },
          },
        },
      },
      {
        id: 'd7f2aa59-f939-46c8-a923-2b2c5d5a51de',
        path: 'metadata-list',
        name: 'metadata-list',
        component: () => {
          return import('../views/metadataManage/metadataList')
        },
        meta: {
          title: '元数据清单',
          keepAlive: false,
          operations: {
            export: {
              id: 0,
              name: 'export',
              desc: '导出',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '316edfde-5611-40dc-a00b-1e5228104bce',
        path: 'collect-task-records',
        name: 'collect-task-records',
        component: () => {
          return import('../views/metadataManage/collectTaskRecords')
        },
        meta: {
          title: '采集任务记录',
          keepAlive: false,
          operations: {
            delete: {
              id: 0,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
    ],
  },
]
